import resourceManager from "../helpers/constant.helper";
import constants from "../helpers/constant.helper";

{
  //drzi sekogas up-to date za da znaes sto validiras
  /* stStartupID	int	Unchecked
stTypeID	int	Unchecked
stCountryID	int	Unchecked
stProvinceID	int	Unchecked
stName	nvarchar(256)	Unchecked
stRegistryNumber	nvarchar(64)	Unchecked
stAddress	nvarchar(256)	Unchecked
stCity	nvarchar(256)	Unchecked
stMobilePhone	nvarchar(256)	Unchecked
stHomePhone	nvarchar(256)	Unchecked
stEmail	nvarchar(256)	Unchecked
stWeb	nvarchar(256)	Unchecked
stSectorID	int	Unchecked
stStartDate	datetime	Unchecked
stRegistrationDate	datetime	Unchecked
stInitStageID	int	Unchecked
stProvinceOperationID	int	Unchecked
stCurrentStatusID	int	Unchecked
stCurrentStageID	int	Unchecked
stDateCreated	datetime	Unchecked
stCreatedBy	int	Unchecked 
*/
}

//sekoe novo properti dodadi go ovde so DEFAULT value
const initialState = {
  Record: {
    acCategoryID: "0",
    acActivityTypeID: "0",
    //acDonorID: '0',      //ovoj e KLUC za od admin ili officers da bira raznlicni startups
    acPartnerID: "0",
    acName: "",
    acDescription: "",
    acComment: "",
    acFrom: "2020-06-26",
    acTo: "2020-06-26",
    StartupIDs: "",
    acDoc1: null,
    acDoc2: null,
  },

  LookupData: [], //Table: LookupData
  ScholarshipCountries: [], //Table: Country
  Provinces: [], //Table: CountryProvince

  Records: [],

  Message: "",
  ValidationMessages: [],
  Loading: false,
  hasError: false,
};

const ImportActivityReducer = (state = initialState, action) => {
  switch (action.type) {
    case "IMPORTACTIVITY_START":
      return {
        ...state,
        Message: resourceManager.MSG_PLEASE_WAIT, //za da izbrise prethoden error ako go imalo
        Loading: true,
        hasError: false,
      };

    case "IMPORTACTIVITY_ERROR":
      return {
        ...state,
        Message: action.error,
        Loading: false,
        hasError: true,
      };

    case "IMPORTACTIVITY_SAVE_ERROR":
      return {
        ...state,
        Message: action.error,
        Record: action.Record,
        ValidationMessages: action.ValidationMessages,
        Loading: false,
        hasError: true,
      };

    case "IMPORTACTIVITY_SAVE_SUCCESS":
      return {
        //...state,
        ...state, //se drugo e vo STATE-ot
        Record: action.Record, //samo noviot record ako e NOV, ako e update si ostanuva IST
        Message: resourceManager.MSG_IMPORT_FINISHED,
        ValidationMessages: [], //resetiraj bila kakva greska
        Loading: false,
        hasError: false,
      };

    case "IMPORTACTIVITY_EDIT":
      return {
        ...state,
        LookupData: action.LookupData,
        Message: "",
        Loading: false,
        hasError: false,
      };

    //se koristi vo find
    case "IMPORTACTIVITY_SEARCH":
      return {
        ...state,
        Records: action.Records, //action.payload == List<Entity>
        Message: "",
        Loading: false,
        hasError: false,
      };

    case "ACTIVITY_PREVIEW":
      return {
        ...state,
        Records: action.Records, //action.payload == List<Entity>
        Message: "",
        Loading: false,
        hasError: false,
      };

    //se koristi vo find
    case "IMPORTACTIVITY_RESET":
      state = initialState; //go resetira na iniital state
      return {
        ...state,
      };

    default:
      return state;
  }
};
export default ImportActivityReducer;
